<div class="full column">
  <div class="row">
     <h4>{{title}}</h4>
  </div>
  <div class="row">
    &nbsp;
  </div>
  <div class="row">
    <div class="field">
      <label>{{ 'ListName' | translate }}:</label>
      <select
              soho-dropdown
              [ngClass]="'dropdown-lg'"
              [attr.id]="'id'"
              [attr.bindId]="'bindId'"
              [(ngModel)]="_listName"
              [attributes]="listNameDropdownAttributes"
      >
        <option *ngFor="let item of listNames" [value]="item.name">{{item.name}}</option>
      </select>
    </div>
  </div>
</div>
